// ギフトラッピング機能
document.addEventListener('DOMContentLoaded', function() {
  console.log('ギフトラッピングスクリプト読み込み開始');

  const giftCheckbox = document.getElementById('gift-wrapping-checkbox');
  const productForm = document.querySelector('form[action*="/cart/add"]');

  // 複数のセレクタでボタンを探す
  let addToCartButton = null;
  if (productForm) {
    addToCartButton = productForm.querySelector('[name="add"]') ||
                     productForm.querySelector('button[type="submit"]') ||
                     productForm.querySelector('.product-form__submit') ||
                     productForm.querySelector('[data-add-to-cart]');
  }

  console.log('チェックボックス:', giftCheckbox);
  console.log('商品フォーム:', productForm);
  console.log('カートに追加ボタン:', addToCartButton);

  if (!giftCheckbox || !productForm) {
    console.warn('チェックボックスまたはフォームが見つかりません');
    return;
  }

  if (!addToCartButton) {
    console.warn('カートに追加ボタンが見つかりません。フォーム送信で処理します。');
  }

  // ギフトラッピングのバリアントID
  const GIFT_WRAPPING_VARIANT_ID = giftCheckbox.dataset.variantId || '51402681188644';
  console.log('ギフトラッピングバリアントID:', GIFT_WRAPPING_VARIANT_ID);

  // イベントハンドラー関数
  function handleAddToCart(e) {
    console.log('カート追加イベント発生');
    console.log('チェックボックスの状態:', giftCheckbox.checked);

    if (giftCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.log('ギフトラッピング追加処理開始');

      // 商品のフォームデータを取得
      const formData = new FormData(productForm);
      const productVariantId = formData.get('id');
      const productQuantity = parseInt(formData.get('quantity') || 1);

      console.log('商品バリアントID:', productVariantId);
      console.log('商品数量:', productQuantity);

      // 商品とギフトラッピングを両方カートに追加
      addItemsToCart(productVariantId, productQuantity);
    }
  }

  // ボタンとフォーム両方にイベントリスナーを設定
  if (addToCartButton) {
    addToCartButton.addEventListener('click', handleAddToCart, true);
    console.log('ボタンクリックイベントリスナー設定完了');
  }

  productForm.addEventListener('submit', handleAddToCart, true);
  console.log('フォーム送信イベントリスナー設定完了');

  // カートに商品とギフトラッピングを追加
  function addItemsToCart(productVariantId, productQuantity) {
    const items = [
      {
        id: productVariantId,
        quantity: productQuantity
      },
      {
        id: GIFT_WRAPPING_VARIANT_ID,
        quantity: productQuantity // 商品の数量と同じ数だけギフトラッピングを追加
      }
    ];

    console.log('カートに追加するアイテム:', items);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => {
      console.log('レスポンスステータス:', response.status);
      return response.json();
    })
    .then(data => {
      console.log('カート追加成功:', data);

      // カートページにリダイレクト、またはカートドロワーを開く
      if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
        // テーマのカート機能をトリガー
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      // カートページにリダイレクト
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('カートへの追加エラー:', error);
      // エラー時は通常のフォーム送信を実行
      productForm.submit();
    });
  }
});
